import { HttpContextToken } from '@angular/common/http';

export enum EnumHttpErrorType {
  None = 0,
  ResponseDto = 1 << 0, // ResponseResult/ResponseFail format (Manual error result)
  ProblemDetails = 1 << 1, // ProblemDetails format or exception dump (Global exception handler)
  Other = 1 << 2, // Other error format that doesn't match the above
  Any = ResponseDto | ProblemDetails | Other, // Any error type
}

export enum EnumHttpSuccessType {
  None = 0,
  Success = 1 << 0, // Any success (200 - 299), using an enum in case we need to add more specific success types in the future
  Any = Success, // Any success type
}

// Available placeholders:
// {msg} - Message extracted from the response be it the success or error message
// {t_not_updated} - Replaced with a translated version of "Not updated" (if applicable)
// {t_not_removed} - Replaced with a translated version of "Not removed" (if applicable)
// {t_not_created} - Replaced with a translated version of "Not created" (if applicable)
// {t_not_found} - Replaced with a translated version of "Not found" (if applicable)
// {t_updated} - Replaced with a translated version of "Updated" (if applicable)
// {t_removed} - Replaced with a translated version of "Removed" (if applicable)
// {t_created} - Replaced with a translated version of "Created" (if applicable)
// {t_success} - Replaced with a translated version of "Success" (if applicable)
// {t_error} - Replaced with a translated version of "Error" (if applicable)
export const ERROR_TOAST_TITLE_TEMPLATE = new HttpContextToken<string>(() => '{t_error}');
export const SUCCESS_TOAST_TITLE_TEMPLATE = new HttpContextToken<string>(() => '{t_success}');
export const ERROR_TOAST_MESSAGE_TEMPLATE = new HttpContextToken<string>(() => '{msg}');
export const SUCCESS_TOAST_MESSAGE_TEMPLATE = new HttpContextToken<string>(() => '{msg}');

export const SUCCESS_TOAST_MASK = new HttpContextToken<EnumHttpSuccessType>(() => EnumHttpSuccessType.None);
export const ERROR_TOAST_MASK = new HttpContextToken<EnumHttpErrorType>(() => EnumHttpErrorType.Any);

export const REAUTH_ON_UNAUTHORIZED_FLAG = new HttpContextToken<boolean>(() => true);
export const ATTEMPT_TO_INJECT_AUTH_HEADERS_FLAG = new HttpContextToken<boolean>(() => true);
export const APPINSIGHTS_LOG_ERROR_MASK = new HttpContextToken<EnumHttpErrorType>(() => EnumHttpErrorType.Any);
